<div class="user-roles">
    <app-loader-icon *ngIf="showLoader"></app-loader-icon>
    <div class="form-group user-roles-form-group" *ngIf="isUserSuperAdmin">
        <div class="col-6">
            <label for="selectUserRole">User logged in as :</label>
        </div>
        <div class="col-6">
            <div class="user-roles-list-wrapper">
                <select class="form-control custom-select" id="selectUserRole" name="userRoles" [(ngModel)]="selectedRole" (change)="onSelectRole($event)" [disabled]="disableUserRoleList">
                    <option *ngFor="let role of userRoleDetails" [attr.selected]="+role.roleId==+selectedRole?true:null"
                    [attr.value]='role?.roleId'>{{role?.roleName}}</option>
                </select>
                <i class="fa fa-chevron-down"></i>
            </div>
        </div>
    </div>
</div>
